import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

import { getFaseOfDay } from "../../../../utils";

import sun from './images/sun.png';
import moon from './images/moon.png';
import sunnyHeightClouds from './images/sunny-height-clouds.png';

import rareCloudsSun from './images/rare-clouds-sun.png';
import rareCloudsMoon from './images/rare-clouds-moon.png';

import cloudySun from './images/cloudy-sun.png';
import cloudyMoon from './images/cloudy-moon.png';

import cloudyRainSun from './images/cloudy-rain-sun.png';

import rainDay from './images/rain-day.png'; 

import foggy from './images/fog.png'; 
import storm from './images/storm.png'; 
import snow from './images/snow.png'; 

const iconMapping = {
    "morning": {
        "clear sky": sun,
        "overcast clouds": cloudySun,
        "scattered clouds": rareCloudsSun,
        "few clouds": rareCloudsMoon,
        "light rain": rainDay,
        "broken clouds": sunnyHeightClouds,
        "Despejado": sun, //
        "Nubes altas": sunnyHeightClouds,
        "Poco nuboso": rareCloudsSun,
        "Nuboso": cloudySun,
        "Bruma": foggy,
        "Niebla": foggy,
        "Muy nuboso": cloudySun,
        "Muy nuboso con lluvia": cloudyRainSun,
        "Muy nuboso con lluvia escasa": cloudyRainSun,
        "Cubierto": sunnyHeightClouds,
        "Cubierto con lluvia": rainDay,
        "Cubierto con lluvia escasa": rainDay,
        "Nuboso con lluvia": rainDay,
        "Nuboso con lluvia escasa": rainDay,
        "moderate rain": rainDay,
        "Intervalos nubosos": sunnyHeightClouds,
        "Intervalos nubosos con lluvia": cloudyRainSun,
        "Intervalos nubosos con lluvia escasa": cloudyRainSun,
        "Intervalos nubosos con tormenta": storm,
        "Cubierto con tormenta y lluvia escasa": storm,
        "Nuboso con tormenta": storm,
        "Cubierto con nieve": snow,
        "Cubierto con nieve escasa": snow,
        "Muy nuboso con nieve escasa": snow
    },
    "night": {
        "clear sky": moon,
        "overcast clouds": cloudyMoon,
        "scattered clouds": rareCloudsMoon,
        "few clouds": rareCloudsMoon,
        "light rain": rainDay,
        "broken clouds": cloudyMoon,
        "Despejado": moon, // 
        "Nubes altas": cloudyMoon,
        "Poco nuboso": rareCloudsMoon, //
        "Nuboso": cloudyMoon,
        "Bruma": foggy,
        "Niebla": foggy,
        "Muy nuboso": cloudyMoon,
        "Muy nuboso con lluvia": cloudyMoon,
        "Muy nuboso con lluvia escasa": cloudyMoon,
        "Cubierto": cloudyMoon,
        "Cubierto con lluvia": rainDay,
        "Cubierto con lluvia escasa": rainDay,
        "Nuboso con lluvia": rainDay,
        "Nuboso con lluvia escasa": rainDay,
        "moderate rain":rainDay,
        "Intervalos nubosos": cloudyMoon,
        "Intervalos nubosos con lluvia": cloudyMoon,
        "Intervalos nubosos con lluvia escasa": cloudyMoon,
        "Intervalos nubosos con tormenta": storm,
        "Cubierto con tormenta y lluvia escasa": storm,
        "Nuboso con tormenta": storm,
        "Cubierto con nieve": snow,
        "Cubierto con nieve escasa": snow,
        "Muy nuboso con nieve escasa": snow
    }
}

const useStyles = makeStyles((theme) => ({
    image: {
        height: 40
    }
}));


export default function SkyImage({ skyState, date, imageHeight }) {
    const classes = useStyles();

    const findSkyStateIcon = () => {
        if (date) return iconMapping[getFaseOfDay(date)][skyState]
        return iconMapping[getFaseOfDay(new Date())][skyState]
    };

    return (
        <Tooltip title={skyState} aria-label={skyState}>
            <img src={findSkyStateIcon()} alt={skyState} style={{height: imageHeight || 40}} />
        </Tooltip>);
}